import { IconButton, IconButtonProps, useTheme } from '@mui/material';

export const CommonDuplicateIconButton = (props: IconButtonProps) => {
  const theme = useTheme();
  return (
    <IconButton size="small" {...props}>
      <i
        className="fa-light fa-copy"
        style={{ color: theme.palette.secondary.main }}
      />
    </IconButton>
  );
};
